/* eslint-disable max-len */
import { fireStore } from './firebase';
import { COLLECTION_NAMES } from './constants';

export const users = fireStore.collection(COLLECTION_NAMES.USERS);
export const products = fireStore.collection(COLLECTION_NAMES.PRODUCTS);
export const transaction = fireStore.collection(COLLECTION_NAMES.TRANSACTIONS);
export const transactionItems = fireStore.collection(COLLECTION_NAMES.TRANSACTIONS_ITEMS);
export const plans = fireStore.collection(COLLECTION_NAMES.PLANS);

export const user = (userID) => users.doc(userID);
export const categoryProducts = (category) => products.where('department', '==', category);
export const product = (productID) => products.doc(productID);

export const defaultCollOptions = {
  idField: 'id'
};
